import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onFetchBestSellerProducts } from './action';

export default function Index() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.BestSeller.allData)

  useEffect(() => {
    if (!products.length > 0) {
      dispatch(onFetchBestSellerProducts());
    }
  }, [dispatch, products.length]);
}